import React, { useEffect, useState } from "react";
import { StyleUtils } from "../../utils/Style";
import { NewBlockView } from "./NewBlockView";
import { HomeTopView } from "./HomeTopView";
import HomeAccountTableView from "./HomeAccountTableView";
import events, { useEventBus } from "../../utils/events";
import { AppEvent } from "../../data/events";
import { UserInfoManager } from "../../utils/UserInfoManager";
import { HomeGuideView } from "./HomeGuideView";
import "./index.css";
import { AppButton, AppMainText } from "../../views/commonview";
import { GlobalUtil } from "../../utils/GlobalText";
import { Link } from "react-router-dom"

const StartMiningButton = () => {
  const [hover, setHover] = useState(false);

  return (
    <div
      style={{
        zIndex: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginTop: StyleUtils.getHeight(27),
      }}
    >
      <button
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        onClick={() => {
          const element = document.getElementById("startMning");
          if (element) {
            window.scrollTo({ top: element.offsetTop, behavior: "smooth" });
          }
        }}
        style={{
          padding: "0.8rem 2rem",
          background: hover
            ? "linear-gradient(90deg, #00CED1 0%, #1E90FF 100%)"
            : "linear-gradient(90deg, #1E90FF 0%, #00CED1 100%)",
          border: "none",
          borderRadius: "50px",
          color: "#fff",
          fontSize: StyleUtils.getFont(16),
          fontWeight: "600",
          cursor: "pointer",
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minWidth: "200px",
          transition: "all 0.3s ease-in-out",
        }}
      >
        <span style={{ display: "flex", alignItems: "center" }}>
          Start Mining Now{" "}
          <span
            style={{
              marginLeft: "0.5rem",
              transform: hover ? "translateX(5px)" : "translateX(0)",
              transition: "transform 0.3s ease-in-out",
            }}
          >
            →
          </span>
        </span>
      </button>
    </div>
  );
};

const hasCurrency = () => {
  return UserInfoManager.currency || localStorage.getItem("currency");
};

const HomePage: React.FC = () => {
  const [changeStyle, setChangeStyle] = useState(true);

  useEffect(() => {
    const onChange = () => setChangeStyle((prev) => !prev);
    events.on(AppEvent.ChangeStyle, onChange);
    events.on(AppEvent.REFRES, onChange);

    return () => {
      events.off(AppEvent.ChangeStyle, onChange);
      events.off(AppEvent.REFRES, onChange);
    };
  }, []);

  return (
    <div
      style={{
        width: "100%",
        justifyContent: "center",
        paddingBottom: StyleUtils.getWidth(36),
        background: StyleUtils.theme().mainColor,
      }}
    >
      {hasCurrency() && (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <div
            className="top-doc"
            style={{
              background: `url(${StyleUtils.getImage("top_bg.png")}) no-repeat center center`,
              width: "auto",
              paddingTop: StyleUtils.getHeight(45),
              paddingBottom: StyleUtils.getHeight(45),
            }}
          >

          <div
            style={{
              display: "flex",
              flexFlow: "column wrap",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "transparent",
            }}
          >
            <div
              style={{
                fontFamily: "Arial, sans-serif",
                fontWeight: "bold",
                fontSize: "48px",
                color: "#FFFFFF",
                whiteSpace: "nowrap",
              }}
            >
              United Hashes
            </div>
            <div
              style={{
                color: StyleUtils.theme().fontColor_1,
                zIndex: 1,
                display: "flex",
                flexFlow: "row wrap",
                columnGap: ".5rem",
                justifyContent: "center",
              }}
            >
              <AppMainText
                text="Unstoppable Growth"
                style={{
                  overflow: "visible",
                  whiteSpace: "pre-wrap",
                  textAlign: "center",
                  fontFamily: "Arial, sans-serif",
                  fontWeight: "bold",
                  fontSize: "48px",
                  color: "#B0E0E6",
                }}
                fontSize={StyleUtils.getFont(32)}
              />
            </div>
          </div>

            <div
              style={{
                color: StyleUtils.theme().fontColor_1,
                lineHeight: "22px",
                zIndex: 1,
                display: "flex",
                padding: "0 1rem",
                flexDirection: "column",
                alignItems: "center",
                fontSize: "1.2rem",
                fontWeight: "700",
                marginTop: StyleUtils.getHeight(7),
              }}
            >
              {[
                "During the promotion period, enjoy 0% pool fees! All mining rewards go directly to your account.",
                "Powered by DRpool’s exclusive Neptune GPU Guess algorithm, dynamically optimize hash collisions with 24/7 stable operation!",
                "Join Neptune Now! The Golden Age of Zero-Commission Mining Starts Here!",
              ].map((text, idx) => (
                <div
                  key={idx}
                  style={{
                    ...StyleUtils.fontStyle_1,
                    display: "flex",
                    marginTop: StyleUtils.getHeight(2),
                  }}
                >
                  {text}
                </div>
              ))}
            </div>
            <div style={{
                 color: StyleUtils.theme().fontColor_1,
                 zIndex: 1,
                 display: "flex",
                 fontFamily: "Arial, sans-serif",
                 fontWeight: "bold",
                 flexFlow: "row wrap",
                 columnGap: ".5rem",
                 justifyContent: "center",
                 marginTop: StyleUtils.getHeight(2),
               }}>
               <img src="/assets/fire.png" height="20px"/>
               DRPool support <span style={{"color":"rgb(0 206 209)"}}>Dual Mining</span> Now! for more information, please <Link to="https://github.com/0xdrpool/neptune_gpu_guesser/blob/main/Dual_Mining.md" target="_blank" style={{color: StyleUtils.theme().fontColor_1,}}>click here</Link>
            </div>
            <StartMiningButton />
          </div>

          <HomeTopView />
          <HomeAccountTableView />
          <NewBlockView />
          <HomeGuideView />
        </div>
      )}
    </div>
  );
};

export default HomePage;
